import React from 'react';
import { Box } from '@mui/material';
import TareasKanban from '../components/tareas/TareasKanban';
import { useAuth } from '../context/AuthContext';
import { Layout } from '../components/layout/Layout';
import { Navigate } from 'react-router-dom';

const Tareas: React.FC = () => {
  const { usuario, loading } = useAuth();

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!usuario) {
    return <Navigate to="/" replace />;
  }

  return (
    <Layout>
      <Box sx={{ height: 'calc(100vh - 64px)', overflow: 'hidden' }}> {/* Full height minus header */}
        <TareasKanban />
      </Box>
    </Layout>
  );
};

export default Tareas;